import React from 'react'
import Sidebar from "../components/sidebar";
import Header from '../components/Header';
import ContactDetail from '../components/Contact/ContactDetail';

function ContactDetailScreen() {
  return (
    <>
        <Sidebar />
        <main className="main-wrap">
            <Header />
            <ContactDetail />
        </main>

    </>
  )
}

export default ContactDetailScreen